module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
    attrs: {
      "title": "Layouts dos Certificados"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__save_form box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Dados do Layout")])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-alert', {
    staticClass: "submission-tips layout-alert",
    attrs: {
      "title": "Dicas para Layout",
      "type": "warning",
      "closable": false
    }
  }, [_c('ul', [_c('li', [_vm._v("O campo conteúdo deve conter o texto do certificado.")]), _vm._v(" "), _c('li', [_vm._v("A imagem deve obrigatóriamemte obedecer as medidas de 1122 pixes de largura e 794 pixels de altura")]), _vm._v(" "), _c('li', [_vm._v("Não se esquece de utilizar as variaveis para informações dinâmicas.")])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.name.$error
    },
    attrs: {
      "label": "Nome"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.$v.form.name.$touch()
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.description.$error
    },
    attrs: {
      "label": "Descrição"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.$v.form.description.$touch()
      }
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.content.$error
    },
    attrs: {
      "label": "Conteúdo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 6
    },
    on: {
      "input": function($event) {
        _vm.$v.form.content.$touch()
      }
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  }), _vm._v(" "), (_vm.$v.form.content.$dirty && _vm.$v.form.content.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo\n                    é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "layout-alert",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "Dicas para formatação do texto:",
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('ul', [_c('li', [_vm._v("[ texto ] : entre colchetes ficará "), _c('b', [_vm._v("negrito")])]), _vm._v(" "), _c('li', [_vm._v("< texto > : entre setas ficará "), _c('i', [_vm._v("itálico")])]), _vm._v(" "), _c('li', [_vm._v("{ texto } : entre chaves ficará "), _c('u', [_vm._v("sublinado")])])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "Para informações dinâmicas utilize:",
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('ul', [_c('li', [_vm._v("$EVENTO_PRINCIPAL : nome do evento principal (Ex.: Congrega 2018) ")]), _vm._v(" "), _c('li', [_vm._v("$EVENTO : nome do evento (Ex.: MIC/Jornada) ")]), _vm._v(" "), _c('li', [_vm._v("$NOME : nome da pessoa (Autor/Participante) ")]), _vm._v(" "), _c('li', [_vm._v("$CARGA_HORARIA : carga horária do evento ")]), _vm._v(" "), _c('li', [_vm._v("$TITULO_TRABALHO: título do trabalho ")]), _vm._v(" "), _c('li', [_vm._v("$AUTORES : autores do trabalho ")]), _vm._v(" "), _c('li', [_vm._v("OBS¹ : Use apenas $TITULO_TRABALHO para certificados de submissão/apresentação de trabalho ou proposta de minicurso ")]), _vm._v(" "), _c('li', [_vm._v("OBS² : Use apenas $NOME ou $AUTORES para evitar duplicação")])])])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Imagem Frente"
    }
  }, [_c('form-single-upload', {
    attrs: {
      "model": _vm.form.image,
      "accepted-types": "image/*"
    },
    on: {
      "update:model": function($event) {
        _vm.$set(_vm.form, "image", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Imagem Verso"
    }
  }, [_c('form-single-upload', {
    attrs: {
      "model": _vm.form.image_back_page,
      "accepted-types": "image/*"
    },
    on: {
      "update:model": function($event) {
        _vm.$set(_vm.form, "image_back_page", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Preview da Imagem Frente"
    }
  }, [(_vm.form.image.name && !_vm.form.image.base64) ? _c('div', {
    staticClass: "preview-image",
    style: ('background-image: url(' + _vm.getLayoutImage + ')')
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Preview da Imagem Verso"
    }
  }, [(_vm.form.image_back_page.name && !_vm.form.image_back_page.base64) ? _c('div', {
    staticClass: "preview-image",
    style: ('background-image: url(' + _vm.getLayoutImageBackPage + ')')
  }) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Assinaturas do Layout"
    }
  }, [_c('el-transfer', {
    attrs: {
      "data": _vm.dependencies.signature,
      "titles": ['Disponíveis', 'Selecionados'],
      "props": {
        key: 'id',
        label: 'name'
      }
    },
    model: {
      value: (_vm.selectedSignature),
      callback: function($$v) {
        _vm.selectedSignature = $$v
      },
      expression: "selectedSignature"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
    attrs: {
      "event-click": _vm.onSend,
      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
      "is-submitted": _vm.isSubmitted
    }
  }), _vm._v(" "), _c('form-cancel-button', {
    attrs: {
      "route-name": "layout.index"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-330887bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/layout/components/Form.vue
// module id = 738
// module chunks = 2